import { render, staticRenderFns } from "./SingularityPanelHeader.vue?vue&type=template&id=1b97633a&"
import script from "./SingularityPanelHeader.vue?vue&type=script&lang=ts&"
export * from "./SingularityPanelHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SingularityPanelHeader.vue?vue&type=style&index=0&id=1b97633a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports